<div id="subs-container">
    <div *ngFor="let sub of subsArr">
        <img [src]="sub" alt="">
    </div>
</div>

